import { Injectable } from '@angular/core';
import { DangerToastComponent } from '../views/shared/toast/danger-toast';
import { SuccessToastComponent } from '../views/shared/toast/success-toast';
import { ToasterComponent, ToasterPlacement } from '@coreui/angular';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toaster: ToasterComponent | null = null;

  setToaster(toaster: ToasterComponent) {
    this.toaster = toaster;
  }

  showErrorToast(message: string) {
    if (this.toaster) {

      this.toaster.addToast(DangerToastComponent, {
        delay: 3000,
        placement: ToasterPlacement.TopEnd,
        autohide: true,
        message: message,
      });
    }
  }

    showSuccessToast(message: string) {
    if (this.toaster) {

      this.toaster.addToast(SuccessToastComponent, {
        delay: 3000,
        placement: ToasterPlacement.TopEnd,
        autohide: true,
        message: message,
      });
    }
  }
}
